/**
 * Table of Contents Toggle
 *
 * @since   1.0.0
 * @package uma
 */

(function($) {

	$('.content-tab').click(function() {
	    $('.table-of-contents').toggleClass('show');
	});

}(jQuery));